import React, { Component } from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import compose from "lodash.flowright";
import ExamReportSection from "../ExamReportSection";
import OverallCollegeReport from "../../../pages/OverallCollegeReport";
import { Container, Nav, Tab, Spinner } from "react-bootstrap";
import * as Cookies from "es-cookie";
import NavbarOne from "../../navbars/NavbarOne";
import SideNavbar from "../../navbars/SideNavbar";
import { isBrowser } from "react-device-detect";
import { withRouter } from "react-router-dom";
import PreloaderTwo from "../../preloader/PreloaderTwo";
import "./_report.scss";
const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      b_e_c_s_data {
        section_id
        class_id
        branch_id
        exam_id
        state_id
        city_id
        district_id
      }
      educationalClasses {
        id
        class
      }
      globalPackages {
        id
        package_name
        exams_covered
      }
      globalCategories {
        id
        category_name
        package_id
      }
      classes {
        id
        class
      }
      exams {
        id
        exam
        exam_subjects{
                subject_id
              }
      }
      globalBranches {
        id
        branch_name
        state_id
        city_id
        district_id
      }
      globalSections {
        id
        section_name
        branch_id
        category_id
        package_id
      }
      offlineExamSubjects{
        id
        subject
      }
      offlineFeeTypes{
        id
        fee_type
      }
         states {
      state_id
      state_name
    }
    districts {
      id
      district_name
      state_id
    }
    cities {
      id
      district_id
      region_id
      city_name
      timestamp
    }
    }
  }
`;

const FETCH_EXAMS = gql`
query($institution_id: Int!){
  getDashBoardExams(institution_id : $institution_id){
    quiz_exams{
      id
      exam_name
      exam_type
      class_id
      start_time

    }
    full_exams{
      id
      exam_mode
      exam_name
      exam_type
      class_id 
      start_time
      end_time
      section{
        id
        section_name
        branch_id
        exam_id
      }
    }
  }
}
`;
class ReportTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: "exam_wise_report",
            selectedScheduleType: null,
            selectedScheduleSubType: null,
            toggled: Cookies.get("toggle")
        };
    }

    componentDidMount() {
        const { globals, students = [] } = this.props;
        if (!globals) return;

    }
    // menuToggler = () => {
    //     const toggle = Cookies.get("toggle") === "sidebar-collapse" ? "" : "sidebar-collapse";
    //     Cookies.set("toggle", toggle);
    //     this.forceUpdate();
    // };

    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    resetForm = () => {
        this.setState({
            selectedScheduleType: null,
            selectedScheduleSubType: null,
        });
    };

    handleTabChange = (key) => {
        this.resetForm();

        this.setState({
            activeTab: key,
        });

        if (this.props.onTabChange) {
            this.props.onTabChange(key);
        }
    };



    render() {
        const { globals } = this.props;

        // if (!globals || globals.loading) {
        //     return (
        //         <div >
        //             <PreloaderTwo />
        //         </div>
        //     );
        // }

        const propsData = {
            classes: globals.globals?.classes || [],
            exams: globals.globals?.exams || [],
            testTypes: { value: 1, label: 'Full Exams' },
            // testNames: getDashBoardExams.getDashBoardExams?.full_exams.filter(exam => exam.exam_mode == 1) || [],
        };
        const getDashBoardExams = this.props.getDashBoardExams.getDashBoardExams || [];
        console.log("Parent component - propsData being sent:", getDashBoardExams);
        console.log("Parent component - globals.globals?.exams:", globals.globals?.exams);
        console.log("Parent component - structure check:", {
            hasGlobals: !!globals,
            hasGlobalsGlobals: !!globals?.globals,
            hasExams: !!(globals?.globals?.exams),
            examsLength: globals?.globals?.exams?.length
        });

        const testTypes = [{ value: 1, label: 'Full Exams' }]


        console.log("propsData", propsData)
        return (
            <div className={Cookies.get("toggle")}>
                {/* Header */}
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />

                </div>

                <div className="main-wrapper">
                    <div
                        id="sidebar"
                        className={
                            isBrowser
                                ? "sidebar-menu d-none d-xl-block d-lg-block"
                                : "sidebar-menu d-block d-xl-none d-lg-none"
                        }
                    >
                        <SideNavbar onClick={this.menuToggler} />
                    </div>
                    {globals?.globals?.exams?.length > 0 ? (
                        <Container fluid className="adaptive-report-wrapper">
                            <Tab.Container
                                activeKey={this.state.activeTab}
                                onSelect={this.handleTabChange}
                            >
                                {/* Main Tabs */}
                                <div className="adaptive-tabs-center">
                                    <Nav className="adaptive-main-tabs">
                                        <Nav.Item>
                                            <Nav.Link eventKey="exam_wise_report">
                                                <i className="fas fa-brain" />
                                                Exam Wise Report
                                            </Nav.Link>
                                        </Nav.Item>

                                        <Nav.Item>
                                            <Nav.Link eventKey="overall_report">
                                                <i className="fas fa-users-cog" />
                                                Overall Report
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </div>

                                {/* Content */}
                                <Tab.Content className="adaptive-tab-content">
                                    <Tab.Pane eventKey="exam_wise_report">
                                        <ExamReportSection globals={propsData} stateData={{ eexamptype: 1 }} getDashBoardExams={getDashBoardExams} testTypes={testTypes} />
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="overall_report">
                                        <OverallCollegeReport globals={propsData} stateData={{ eexamptype: 1 }} getDashBoardExams={getDashBoardExams} testTypes={globals.globals?.testTypes} />
                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </Container>
                    ) : (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                            <PreloaderTwo />
                        </div>
                    )}
                </div>


            </div>
        );
    }
}

export default compose(
    withRouter,

    graphql(FETCH_GLOBALS, {
        options: () => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "globals",
    }),
    graphql(FETCH_EXAMS, {
        options: () => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "getDashBoardExams",
    }),

)(ReportTabs);